import OrderDetail from './order-detail'
export default OrderDetail